import { useField } from '@arc/frontend/util-common';
import { Checkbox } from './Checkbox';
export function CheckboxWithControl(props) {
  const {
    name,
    beforeChange,
    onChangeEffect,
    ...other
  } = props;
  const {
    field: {
      ref,
      value,
      onChange
    }
  } = useField({
    name
  });
  return <Checkbox ref={ref} checked={!!value} onChange={() => {
    // @ts-expect-error `data-*` attributes are not in the type definition
    if (props['data-disabled']) return;
    if (beforeChange && beforeChange(!value) === false) return;
    if (onChangeEffect) onChangeEffect(!value);
    onChange(!value);
  }} {...other} />;
}